/**
 * AdminNodeRpcClient - AtomRpc integration for admin node endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminNodeRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminNodeRpcClient extends AtomRpc.Tag<AdminNodeRpcClient>()(
  "AdminNodeRpcClient",
  {
    group: AdminNodeRpcs,
    protocol: makeRpcClientLayer(AdminNodeRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
